module.exports = __webpack_public_path__ + "media/images/iconClose__okGreen--dark-68382c78ab988fa5dfaeeda8308983b1.png";